export default {
  title: 'CONSUMER CLIENTS',
  items: {
    HideUnavailableServices: {
      label: 'Hide Unavailable Services',
      type: 'boolean'
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/consumer-clients.js